import isBefore from 'date-fns/isBefore';
import parse from 'date-fns/parse';
import startOfDay from 'date-fns/startOfDay';
import Fluxxor from 'fluxxor';
import lscache from 'lscache';

export const constants = {
  SET_GUESTS: 'EXPERIENCE_FILTER:SET_GUESTS',
  SET_DATE_TIME: 'EXPERIENCE_FILTER:SET_DATE_TIME',
  SET_DATE: 'EXPERIENCE_FILTER:SET_DATE',
  SET_TIME: 'EXPERIENCE_FILTER:SET_TIME',
  SET_SELECTED_HOST: 'EXPERIENCE_FILTER:SET_SELECTED_HOST',
  TOGGLE_LANGUAGE: 'EXPERIENCE_FILTER:TOGGLE_LANGUAGE',
  RESET_STORE: 'EXPERIENCE_FILTER:RESET_STORE',
};

const TODAY = new Date();

export const ExperienceFilterStore = Fluxxor.createStore({
  initialize() {
    this.resetStore();

    this.bindActions(
      constants.SET_GUESTS,
      this.onSetGuests,
      constants.SET_DATE_TIME,
      this.onSetDateTime,
      constants.SET_TIME,
      this.onSetTime,
      constants.SET_DATE,
      this.onSetDate,
      constants.SET_SELECTED_HOST,
      this.onSetSelectedHost,
      constants.TOGGLE_LANGUAGE,
      this.onToggleLanguage,
      constants.RESET_STORE,
      this.resetStore,
    );
  },

  onSetGuests(guests) {
    this.adults = guests.nrOfAdults;
    this.children = guests.nrOfChildren;
    this.emit('change');
  },

  onSetDateTime({ date, time }) {
    if (!!date && !this.isBeforeToday(date)) {
      this.date = date;
    }

    if (!!time) {
      this.time = time;
    }
    this.emit('change');
  },

  onSetDate({ date }) {
    if (!this.isBeforeToday(date)) {
      this.date = date;
      this.emit('change');
    }
  },

  onSetTime({ time }) {
    this.time = time;
    this.emit('change');
  },

  onSetSelectedHost({ host }) {
    this.host = host;
    this.emit('change');
  },

  onToggleLanguage({ languages }) {
    this.languages = [...languages];
    this.emit('change');
  },

  getAdults() {
    return this.adults;
  },

  getChildren() {
    return this.children;
  },

  getSelectedHost() {
    return this.host;
  },

  getDate() {
    return this.date;
  },

  getDefaultDate() {
    return this.searchDate || this.urlDate;
  },

  getTime() {
    return this.time;
  },

  getLanguages() {
    return this.languages;
  },

  getFilters() {
    return {
      adults: this.adults,
      children: this.children,
      date: this.date,
      time: this.time,
      languages: this.languages,
      host: this.host,
    };
  },

  resetStore() {
    const searchParams = new URLSearchParams(window.location.search);
    const searchParamsAdults = searchParams.get('adults');
    const searchParamsChildren = searchParams.get('children');
    const searchParamsDate = searchParams.get('date');

    this.adults =
      parseInt(searchParamsAdults || lscache.get('adults'), 10) || 4;
    this.children =
      parseInt(searchParamsChildren || lscache.get('children'), 10) || 0;
    this.searchDate = lscache.get('date_from');
    this.urlDate = searchParamsDate ? searchParamsDate : null;
    this.date = this.searchDate || this.urlDate;
    if (this.date && this.isBeforeToday(this.date)) {
      this.date = null;
    }
    this.time = null;
    this.languages = [];
    this.host = null;
  },

  shouldDateBeUpdatedWithFirstAvailableDate(dates) {
    return (
      (!this.date && !this.searchDate && !this.urlDate && dates) ||
      (dates &&
        dates.length &&
        !dates.includes(this.searchDate) &&
        !dates.includes(this.urlDate))
    );
  },

  isBeforeToday(date) {
    return isBefore(
      startOfDay(parse(date, 'yyyy-MM-dd', new Date())),
      startOfDay(TODAY),
    );
  },
});
